'use client';

import { useAnalyticsSkuViewedContext } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed/Context';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { RatesAndFeesLink } from 'src/features/product-card/RatesAndFeesLink';
import type { CtaAnalyticsProps } from '../../types';

export function RatesAndFeesAnalyticsLink({
  analytics,
  href,
  versionId,
  actionSection,
  name,
}: {
  analytics: CtaAnalyticsProps;
  href: string;
  versionId: number;
  actionSection: string;
  name: string;
}) {
  const { skuImpressionId } = useAnalyticsSkuViewedContext();
  const fireRatesAndFeesPageAction = usePageAction({
    actionName: 'rates_and_fees',
    actionSection: actionSection,
    actionType: 'open',
    additionalAttributes: {
      sku_impression_id: skuImpressionId,
    },
  });

  return (
    <RatesAndFeesLink
      analytics={analytics}
      href={href}
      versionId={versionId}
      onClickAnalyticsCallback={fireRatesAndFeesPageAction}
      containerSxProps={{ fontSize: '1rem' }}
      name={name}
    >
      View Rates & Fees
    </RatesAndFeesLink>
  );
}
